import _ from "lodash";

/**
 * Normalize a stats cell for lodash/Angular orderBy. Currency and custom-field
 * objects must sort by their numeric payload, not as opaque objects.
 */
export function sortStatValue(val: any, extra?: string): number | string {
  if (_.isObject(val) && extra && _.isFinite(val[extra])) {
    return val[extra];
  }
  if (_.get(val, 'currency')) {
    return _.isFinite(val.amount) ? val.amount : -1;
  }
  const count = _.get(val, 'count');
  if (_.isObject(val) && _.isFinite(count)) {
    return count;
  }
  if (_.isNil(val) || (_.isObject(val) && _.isEmpty(val))) {
    return -1;
  }
  return val;
}

function check(og, num) {
  if (num > -1) {
    return num;
  }
  return sortStatValue(og.value);
}

export function statComparator(v1, v2) {
  const v1Value = check(v1, v1.value || -1);
  const v2Value = check(v2, v2.value || -1);
  return (v1Value > v2Value) ? -1 : 1;
}